/**
 * CommandCentreSection — visual grouping frame for the Admin Command Centre.
 * 2026-07-03
 *
 * Robert asked for coloured section frames so it's obvious where each
 * block of related tiles starts and stops. This is the wrapper that
 * gives every group its own accent rail, icon, title, and subtitle.
 *
 * All the actual styling lives in AdminHome.css under `.cc-section` so
 * the rules can never be shadowed by a nested card's own Tailwind.
 */
import React from 'react';

/**
 * @param {{title:string, subtitle?:string, accent?:string, icon?:React.ReactNode,
 *          testId?:string, children:React.ReactNode}} props
 */
export const CommandCentreSection = ({
  title,
  subtitle,
  accent = '#F5831F',
  icon,
  testId,
  children,
}) => {
  // `id` doubles as the anchor target for CommandCentreSubNav's
  // section-jump pills. Reuses testId so we never drift between the
  // subnav registry and the actual DOM anchor.
  const sectionId = testId || `cc-section-${title.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <section
      id={sectionId}
      className="cc-section"
      style={{ '--cc-accent': accent }}
      data-testid={sectionId}
    >
      <header className="cc-section-header">
        {icon && <span className="cc-section-icon" aria-hidden>{icon}</span>}
        <div className="min-w-0">
          <div className="cc-section-title">{title}</div>
          {subtitle && <div className="cc-section-subtitle">{subtitle}</div>}
        </div>
      </header>
      <div className="cc-section-body">{children}</div>
    </section>
  );
};

export default CommandCentreSection;
